<template>
  <div id="app" class="h-screen w-screen overflow-hidden">
    <notifications position="top center" style="top: 100px !important" />
    <router-view />
  </div>
</template>
